<template>
    <!-- Momento 2 es reclamo -->
    <chat
    :tipo="5"
    :user="id_pedido"
    :momento="2"
    :finalizado="detalle.estado == 32"
    :fecha-finalizado="detalle.fecha_ult_reclamo"
    @actualizar-lectura="actualizarLectura"
    />
</template>

<script>
import {mapGetters} from 'vuex'
import ReclamosLeecheros from '~/services/reclamos/reclamosLeecheros'

export default {
    computed:{
        ...mapGetters({
            id_pedido: 'pedidos/pedidos_historial_admin/id_pedido',
            detalle: 'pedidos/pedidos_historial_admin/pedido',
        }),
    },
    methods: {

        async actualizarLectura(){
            console.log('-----  ----actualizarLecturaa-   -------', );
            await this.actualizarUltimaLectura()
        },
        async actualizarUltimaLectura(){
            try {
                const enviar ={
                    id_pedido: this.id_pedido
                }
                const {data} = await ReclamosLeecheros.actualizarUltimaLectura(enviar)

            } catch (e){
                this.error_catch(e)
            }
        },
    }
}
</script>

<style lang="css" scoped>
</style>
